module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chooseMapel"
    }
  }, [_c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "items": _vm.mapels,
      "outlined": "",
      "dense": "",
      "item-text": "nama",
      "item-value": "code",
      "placeholder": "Ketik mata pelajaran"
    },
    on: {
      "click": function($event) {
        return _vm.showMapels()
      },
      "change": _vm.selectMapel
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          staticClass: "pa-0 ma-0"
        }, [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": item.picture
          }
        })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.nama))])], 1)]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": item.picture
          }
        })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.nama))])]
      }
    }]),
    model: {
      value: (_vm.selectedMapel),
      callback: function($$v) {
        _vm.selectedMapel = $$v
      },
      expression: "selectedMapel"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f3eb8d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tryout/components/ChooseMapel.vue
// module id = 1507
// module chunks = 1